import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import classNames from 'classnames';

import { Typography2 } from '@coursera/cds-core';
import { SvgFacebook } from '@coursera/coursera-ui/svg';

import SocialButton from 'bundles/authentication-common/components/sso/SSOButton';
import withSocialSSO from 'bundles/authentication-common/hocs/SocialSSO';
import useTrackClickButton from 'bundles/authentication-common/hooks/useTrackClickButton';
import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/authentication';

const TrackedSocialButton = withSingleTracked({ type: 'BUTTON' })(SocialButton);

type Props = {
  className?: string;
  onClick?: () => void;
  btnLabel?: string;
  customStyles?: SerializedStyles;
  iconColor?: string;
};

const Facebook = React.forwardRef(
  ({ className, onClick, btnLabel, customStyles, iconColor }: Props, ref: React.Ref<HTMLElement>) => {
    const { trackButton } = useTrackClickButton();
    const handleOnClick = () => {
      trackButton({ name: 'signup_with_facebook' });
      onClick?.();
    };
    return (
      <TrackedSocialButton
        className={classNames(className, 'FacebookAlternative')}
        customStyles={customStyles}
        icon={SvgFacebook}
        iconColor={iconColor ?? '#3b5998'}
        onClick={handleOnClick}
        trackingName="continue_with_facebook_auth_btn"
        _refAltAsTrueRef={ref}
      >
        {btnLabel ?? (
          <Typography2 component="span" variant="actionSecondary" color="inherit">
            {_t('Continue with Facebook')}
          </Typography2>
        )}
      </TrackedSocialButton>
    );
  }
);
Facebook.displayName = 'Facebook';

export default withSocialSSO(Facebook, 'facebook');
